import { ExerciseComplianceSection } from '../../ExerciseComplianceSection';
import { PerformedTreatmentsSection } from './PerformedTreatmentsSection';
import { TreatmentPlansSection } from './TreatmentPlansSection';

interface TreatmentsTabProps {
  patientId: string;
  hasTreatmentPlans: boolean;
}

export function TreatmentsTab({ patientId, hasTreatmentPlans }: TreatmentsTabProps) {
  return (
    <div className="grid gap-5 lg:grid-cols-2 items-start">
      {hasTreatmentPlans === false ? null : <TreatmentPlansSection patientId={patientId} />}
      <PerformedTreatmentsSection patientId={patientId} />
      {hasTreatmentPlans === false ? null : (
        <div className="lg:col-span-2">
          <ExerciseComplianceSection patientId={patientId} />
        </div>
      )}
    </div>
  );
}
